const data = [
    { "id": "AC", "name": "Acre" },
    { "id": "AL", "name": "Alagoas" },
    { "id": "AP", "name": "Amapá" },
    { "id": "AM", "name": "Amazonas" },
    { "id": "BA", "name": "Bahia" },
    { "id": "CE", "name": "Ceará" },
    { "id": "DF", "name": "Distrito Federal" },
    { "id": "ES", "name": "Espírito Santo" },
    { "id": "GO", "name": "Goiás" },
    { "id": "MA", "name": "Maranhão" },
    { "id": "MT", "name": "Mato Grosso" },
    { "id": "MS", "name": "Mato Grosso do Sul" },
    { "id": "MG", "name": "Minas Gerais" },
    { "id": "PR", "name": "Paraná" },
    { "id": "PB", "name": "Paraíba" },
    { "id": "PA", "name": "Pará" },
    { "id": "PE", "name": "Pernambuco" },
    { "id": "PI", "name": "Piauí" },
    { "id": "RN", "name": "Rio Grande do Norte" },
    { "id": "RS", "name": "Rio Grande do Sul" },
    { "id": "RJ", "name": "Rio de Janeiro" },
    { "id": "RO", "name": "Rondônia" },
    { "id": "RR", "name": "Roraima" },
    { "id": "SC", "name": "Santa Catarina" },
    { "id": "SE", "name": "Sergipe" },
    { "id": "SP", "name": "São Paulo" },
    { "id": "TO", "name": "Tocantins" }
]

export default [...data];